import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { evaluateRoute } from '../utils/seoPolicy';
import { useRobotsClaimed } from '../utils/robotsOwnership';
import approvedPaths from '../generated/seo-approved-paths.json';

/**
 * The single authority for robots + canonical on every route except editorial guides (DynamicPage)
 * and not-found pages, which decide for themselves and claim robots ownership.
 * Page components must NOT emit their own robots or canonical tags.
 * Rules live in src/utils/seoPolicy.js (evaluateRoute); approval comes from seo/sitemap-manifest.json.
 * No network or database access, so the decision is immediate and cannot race other Helmets.
 */
export function SEORobotsTag() {
  const location = useLocation();
  const claimed = useRobotsClaimed();
  if (claimed) return null;

  const { robots, canonical } = evaluateRoute({
    pathname: location.pathname,
    search: location.search,
    approved: approvedPaths,
  });

  return (
    <Helmet>
      <meta name="robots" content={robots} />
      <meta name="googlebot" content={robots} />
      {canonical && <link rel="canonical" href={canonical} />}
    </Helmet>
  );
}
